
import { Component, Vue } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";

@Component({
	components: {
		DatePicker,
	},
})
export default class TurnoverView extends Vue {
	private loading: boolean = false;
	private turnover: any | null = null;
	private startDate: string = moment().subtract(1, "year").format("YYYY-01-01 00:00:00");
	private endDate: string = moment().subtract(1, "year").format("YYYY-12-31 23:59:59");

	private mounted() {
		this.getUmsatz();
	}

	private async getUmsatz() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetTurnoverReport?from=${this.startDate}&to=${this.endDate}`
			);
			this.turnover = response.data;
		} catch {
			this.$store.commit("setSnackbarErrorText", "Umsätze konnten nicht geladen werden.");
		} finally {
			this.loading = false;
		}
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD 00:00:00");
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD 23:59:59");
	}
}
